/**
 * Darette Free Gift Auto-Add v2 (2026-08-20 替换制)
 * 四档 highest-only：只保留满足的最高一档，低档礼物自动换掉（Adam 拍板：累加太粗糙）。
 *   >= $50  ($48)  -> The Petal Covers 胸贴 $11
 *   >= $100 ($98)  -> Lights Out Silk Eye Mask 眼罩 $24
 *   >= $150 ($148) -> The Understudy Scrunchie Set 发圈 $36
 *   >= $200 ($198) -> Night Shift Silk Pillowcase 枕套 $52
 * 20% off 档已删（折扣同日删除）。免邮 $89（2026-10-24 起，原 $100）。阈值与 BXGY 配置一致取 48/98/148/198(全店定价 X8.99,预留 $1 头寸)。
 * 门槛按 shop currency(USD) 比较，cart.js 是 presentment 币需换算。
 * v2.3-drawer (2026-09-26, 抽屉 A2/A5/A8)：
 *   - add/change 带 sections 参数，cart:update 事件里附 data.sections -> cart-items-component 直接 morph 响应里的 HTML（同步、
 *     不再二次 renderSection 拉整个 header section）；data.silent=true -> cart-drawer.js 不因赠品同步而弹开抽屉；
 *     itemCount 只数付费件（角标不再把赠品算进去）。
 *   - renderRewardUI 同时刷新 [data-dr-line] 一行礼物状态 与 总价下 [data-dt-taxnote]（免邮达标文案，USD 口径同进度条）。
 *   - continueCheckout 用 trigger.form（结账键现在在 #cart-form 外，靠 form="cart-form" 绑定）。
 */
(function () {
  var GIFT_PROP_KEY = "_darette_gift";
  var VERSION = "v2.6-buy2";
  var FREE_SHIPPING_THRESHOLD = 8900; // $89 USD cents (2026-10-24 Adam: $100 -> $89, same day as the shipping rates; was $100 since 2026-08-06)
  // 2026-10-24 under-$89 Standard rate by country (USD cents), mirrors the General profile zones: Australia $13, everywhere else $10.
  var SHIP_RATES = { AU: 1300 }, SHIP_RATE_DEFAULT = 1000;
  function shipRateCents() { try { var c = (window.Shopify && window.Shopify.country) || ""; return SHIP_RATES[c] || SHIP_RATE_DEFAULT; } catch (e) { return SHIP_RATE_DEFAULT; } }

  // 替换制档位（低→高）：只送满足的最高一档。threshold 与 BXGY 折扣配置一致(48/98/148/198，比对外说的 50/100/150/200 低 $2 作汇率/折后余量)；
  // 对外文案一律用 display：公告/折扣名/「unlocks at」/「$X more」都数到 $50，门槛判定仍按 threshold（2026-10-24 复查统一）。
  var TIERS = [
    { key: "petal",     threshold: 4800,  display: 5000,  variantId: 49067619877114, name: "The Petal Covers",             value: "$11 value" },
    { key: "mask",      threshold: 9800,  display: 10000, variantId: 50140353265914, name: "Lights Out Silk Eye Mask",     value: "$24 value" },
    { key: "scrunchie", threshold: 14800, display: 15000, variantId: 50140353331450, name: "The Understudy Scrunchie Set", value: "$36 value" },
    { key: "pillow",    threshold: 19800, display: 20000, variantId: 50140353495290, name: "Night Shift Silk Pillowcase",  value: "$52 value" }
  ];
  var GIFT_VARIANTS = TIERS.map(function (t) { return t.variantId; });
  /* v2.6 (2026-11-05, "Buy 2 Save 20%" on the Do Not Disturb mask): Shopify will not use a line that already carries another
     discount as the qualifying purchase of a Buy-X-Get-Y gift, so a bag of two discounted masks got its "free" gift charged.
     Gift tiers now count only undiscounted lines (q.giftTotal), exactly as Shopify does; free shipping still counts everything.
     So two masks on the offer get the 20% and no gift; a mask plus anything at full price still earns gifts as before.
     PETAL_ALWAYS_FREE is the switch for "two masks keep the Petal Covers too": it needs a separate automatic discount that makes
     that gift free whenever it is in the bag (not created yet, Adam's call).
     With no discounted line in the bag giftTotal === shopTotal and nothing changes. */
  var PETAL_ALWAYS_FREE = false; // flip to true only after the automatic discount "Free Petal Covers" exists (see _脚本/v8_buy2_discount.py petal)
  function tierBase(t, q) { return (PETAL_ALWAYS_FREE && t.key === "petal") ? q.shopTotal : q.giftTotal; }
  function highestTier(q) {
    var cur = null;
    TIERS.forEach(function (t) { if (tierBase(t, q) >= t.threshold) cur = t; });
    return cur;
  }

  var syncing = false, lastSync = 0, syncPromise = null, debugLogged = false, checkoutGuardBypass = false;

  function log() { try { console.log.apply(console, ["[Darette gift " + VERSION + "]"].concat([].slice.call(arguments))); } catch (e) {} }

  function shopCurrencyRate() {
    try { var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate); return (r && r > 0) ? r : 1; } catch (e) { return 1; }
  }
  function activeCurrency() {
    try { var c = window.Shopify && window.Shopify.currency && window.Shopify.currency.active; return c || "USD"; } catch (e) { return "USD"; }
  }
  function formatUsdCents(usdCents, roundMode) {
    var rate = shopCurrencyRate();
    var localCents = Math.max(0, Math.round(usdCents * rate));
    var units = roundMode === "ceil" ? Math.ceil(localCents / 100) : Math.round(localCents / 100);
    if (usdCents > 0) units = Math.max(1, units);
    try { return new Intl.NumberFormat(undefined, { style: "currency", currency: activeCurrency(), minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(units); }
    catch (e) { return (activeCurrency() === "USD" ? "$" : activeCurrency() + " ") + units; }
  }

  function isGift(item) {
    if (!item || GIFT_VARIANTS.indexOf(item.variant_id) === -1) return false;
    var p = item.properties;
    return !!p && (p[GIFT_PROP_KEY] === "true" || p[GIFT_PROP_KEY] === true);
  }

  function paidCount(cart) {
    var n = 0; (cart && cart.items || []).forEach(function (item) { if (!isGift(item)) n += item.quantity || 0; }); return n;
  }
  function sectionIds() {
    var ids = []; try { [].forEach.call(document.querySelectorAll("cart-items-component"), function (c) { if (c.dataset && c.dataset.sectionId) ids.push(c.dataset.sectionId); }); } catch (e) {}
    return ids;
  }
  var lastSections = null; // sections HTML from the latest gift add/remove response (see refreshCartSection)

  function getCartQualification(cart) {
    var qualifyingTotal = 0, undiscounted = 0;
    (cart.items || []).forEach(function (item) {
      if (isGift(item)) return;
      qualifyingTotal += item.line_price || 0;
      if (!((item.line_price || 0) < (item.original_line_price || 0))) undiscounted += item.line_price || 0;
    });
    var rate = shopCurrencyRate();
    var toShop = function (v) { return rate === 1 ? v : Math.round(v / rate); };
    return { presentmentTotal: qualifyingTotal, shopTotal: toShop(qualifyingTotal), giftTotal: toShop(undiscounted), rate: rate };
  }

  // ===== 渲染：免邮进度条 + 两档 reward item =====
  function renderRewardUI(cart, q) {
    try {
      q = q || getCartQualification(cart);
      var rate = q.rate;
      var shipUnlocked = q.shopTotal >= FREE_SHIPPING_THRESHOLD;
      var shipNeed = Math.max(0, FREE_SHIPPING_THRESHOLD - q.shopTotal);
      var shipPct = Math.max(0, Math.min(100, Math.round(q.shopTotal * 100 / FREE_SHIPPING_THRESHOLD)));
      var currentTier = highestTier(q);
      var nextTier = null; TIERS.forEach(function (t) { if (!nextTier && tierBase(t, q) < t.threshold) nextTier = t; });
      if (q.giftTotal < q.shopTotal) nextTier = null; // some lines are on an offer: don't promise a next gift at a spend that would not unlock it

      // A5: "Free shipping ✓ · taxes calculated at checkout" under the total once the USD-equivalent subtotal clears the bar (cart-summary [data-dt-taxnote])
      [].forEach.call(document.querySelectorAll("[data-dt-taxnote]"), function (n) {
        var f = n.querySelector("[data-dt-taxnote-free]"), d = n.querySelector("[data-dt-taxnote-default]");
        if (f) f.hidden = !shipUnlocked; if (d) d.hidden = shipUnlocked;
      });
      // 2026-10-24 A1a: say the shipping price before checkout ("Shipping $10 · free over $89", Australia $13) in the shopper's currency
      [].forEach.call(document.querySelectorAll("[data-dt-shipnote]"), function (n) {
        n.textContent = "Shipping " + formatUsdCents(shipRateCents()) + " \u00b7 free over " + formatUsdCents(FREE_SHIPPING_THRESHOLD);
        n.style.visibility = "";
      });

      var roots = document.querySelectorAll("[data-darette-rewards]");
      if (!roots.length) return;

      roots.forEach(function (root) {
        var headline = root.querySelector("[data-dr-headline]");
        if (headline) {
          headline.textContent = "";
          if (shipUnlocked) {
            headline.appendChild(document.createTextNode("Free shipping "));
            var em = document.createElement("em"); em.textContent = "included"; headline.appendChild(em);
          } else {
            headline.appendChild(document.createTextNode("You're "));
            var em2 = document.createElement("em"); em2.textContent = formatUsdCents(shipNeed, "ceil") + " away"; headline.appendChild(em2);
            headline.appendChild(document.createTextNode(" from free shipping"));
          }
        }
        var fill = root.querySelector("[data-dr-fill]"); if (fill) fill.style.width = shipPct + "%";
        var count = root.querySelector("[data-dr-count]"); if (count) count.textContent = currentTier ? (currentTier.name + " · yours") : "unlock at " + formatUsdCents(TIERS[0].display);
        // A2: one-line gift status (drawer shows this instead of the accordion)
        var line = root.querySelector("[data-dr-line]");
        if (line) {
          var txt = currentTier ? ("\u2713 " + currentTier.name + " · yours") : "";
          if (nextTier) txt += (txt ? " · " : "") + formatUsdCents((nextTier.display || nextTier.threshold) - tierBase(nextTier, q), "ceil") + " more for " + (currentTier && !/^the /i.test(nextTier.name) ? "the " : "") + nextTier.name + (currentTier ? "" : " (" + nextTier.value + ")");
          line.textContent = txt;
        }
        // bar endpoints in the shopper's currency (were hard-coded "$0"/"$75" while the headline converted — mixed-currency bug)
        var barStart = root.querySelector("[data-dr-bar-start]"); if (barStart) barStart.textContent = formatUsdCents(0);
        var barEnd = root.querySelector("[data-dr-bar-end]"); if (barEnd) barEnd.textContent = formatUsdCents(FREE_SHIPPING_THRESHOLD) + " · Free Shipping";

        TIERS.forEach(function (tier) {
          var item = root.querySelector('[data-dr-reward="' + tier.key + '"]'); if (!item) return;
          var unlocked = tierBase(tier, q) >= tier.threshold;
          item.classList.toggle("is-unlocked", unlocked);
          var isCurrent = !!(currentTier && tier.key === currentTier.key);
          item.classList.toggle("is-current", isCurrent);
          var unlockEl = item.querySelector('[data-dr-unlock]');
          if (unlockEl) unlockEl.textContent = "· unlocks at " + formatUsdCents(tier.display || tier.threshold);
          var value = item.querySelector("[data-dr-value]");
          if (value) value.textContent = isCurrent ? tier.value + " · Free, in your bag" : (unlocked ? "Upgraded ↑" : tier.value);
          var status = item.querySelector("[data-dr-status]");
          if (!status && !unlocked) {
            var right = item.querySelector(".dr-rewards__right");
            if (right) { status = document.createElement("span"); status.className = "dr-rewards__status"; status.setAttribute("data-dr-status", ""); right.appendChild(status); }
          }
          if (status) { status.textContent = unlocked ? "" : formatUsdCents((tier.display || tier.threshold) - tierBase(tier, q), "ceil") + " more"; status.style.display = unlocked ? "none" : ""; }
          var marker = item.querySelector("[data-dr-marker] svg"); // icon 切换由 class 控色，路径切换可选
        });
        root.style.visibility = ""; // 非 USD 初帧隐藏（liquid 侧），JS 换算渲染完亮出
      });
    } catch (e) {}
  }

  function fetchCart() { return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }); }

  function refreshCartSection() {
    /* v2.4 (2026-10-08): addGift 改 update.js+change.js（见函数内注释），不再触发 Meta AddToCart。
     * v2.3 (2026-09-26): 事件里附 data.sections（来自 add/change 响应）-> cart-items-component 走 morphSection(sections[id])，
       同步、无二次请求；data.silent -> cart-drawer.js 不 showDialog（赠品同步永远不该自己弹抽屉，加购那次 CartAddEvent 已经开过了）；
       itemCount = 付费件数（cart-icon.js 直接拿它写角标）。
       v2.1 (2026-08-29): 走 Horizon 正道——广播 cart:update，cart-items-component 收到后自己
       sectionRenderer.renderSection + morphSection 增量刷新，抽屉 dialog 不动。
       旧实现 fetch /cart 后把 cart-items 所在的整个 section（在 PDP 上=header，含打开中的抽屉 dialog）
       整段替换 -> 打开状态的 dialog 被销毁、scroll-lock 不释放 -> 整页冻死。
       这是 8 月广告期「加购->结账 10%」的根因（2026-08-29 Adam 实机复现定案）。 */
    return fetchCart().then(function (cart) {
      var sections = lastSections; lastSections = null;
      document.dispatchEvent(new CustomEvent("cart:update", { bubbles: true, detail: {
        resource: cart, sourceId: "darette-free-gift",
        data: { source: "darette-free-gift", itemCount: paidCount(cart), sections: sections || undefined, silent: true } } }));
      return true;
    }).catch(function () { return false; });
  }

  function keepSections(res) { if (res && res.sections) lastSections = res.sections; return res; }
  /* v2.5 (2026-10-08): 实测 update.js 加赠品 Shopify 仍发 product_added_to_cart → Meta AddToCart 照样多打一次。
     根治：赠品加行期间把 Meta 像素的 AddToCart 丢掉（FB&IG 渠道像素跑在页面上下文，fbq 可包一层）。只在 __dtGiftAdding 为真的 2.5 秒内丢，
     顾客自己加购不受影响。 */
  function guardFbq() {
    if (window.__dtFbqGuard || typeof window.fbq !== "function") return;
    var o = window.fbq;
    var w = function () {
      try {
        var a = arguments, ev = (a[0] === "trackShopify" ? a[2] : a[1]);
        if (window.__dtGiftAdding && ev === "AddToCart") { log("drop gift AddToCart pixel"); return; }
      } catch (e) {}
      return o.apply(this, arguments);
    };
    for (var key in o) { try { w[key] = o[key]; } catch (e) {} }
    window.fbq = w; window.__dtFbqGuard = 1;
  }
  function addGift(variantId) {
    /* v2.4 (2026-10-08): 赠品不再走 /cart/add.js —— 那一下会被 Shopify 像素当成顾客加购（product_added_to_cart），Meta AddToCart 一次点击打两次
       （10-08 实测：袍 + 眼罩各一次），加购数翻倍、加购→结账看起来只有一半。改成 /cart/update.js 加行（不发标准加购事件）
       + /cart/change.js 给这一行打 _darette_gift 属性（抽屉据它显示 Free gift、付费件数据它排除）。 */
    var hdr = { "Content-Type": "application/json", Accept: "application/json" };
    var upd = {}; upd[String(variantId)] = 1;
    guardFbq(); window.__dtGiftAdding = true; setTimeout(function () { window.__dtGiftAdding = false; }, 2500);
    return fetch("/cart/update.js", { method: "POST", credentials: "same-origin", headers: hdr,
      body: JSON.stringify({ updates: upd, sections: sectionIds().join(","), sections_url: window.location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = null;
        (cart && cart.items || []).forEach(function (it) { if (!line && it.variant_id === variantId && !isGift(it)) line = it; });
        if (!line) return cart;
        var props = {}; props[GIFT_PROP_KEY] = "true";
        return fetch("/cart/change.js", { method: "POST", credentials: "same-origin", headers: hdr,
          body: JSON.stringify({ id: line.key, quantity: 1, properties: props, sections: sectionIds().join(","), sections_url: window.location.pathname }) })
          .then(function (r) { return r.json(); });
      }).then(keepSections);
  }
  function removeGift(lineKey) {
    return fetch("/cart/change.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: lineKey, quantity: 0, sections: sectionIds().join(","), sections_url: window.location.pathname }) }).then(function (r) { return r.json(); }).then(keepSections);
  }

  function sync(force) {
    var now = Date.now();
    if (syncing) return syncPromise || Promise.resolve();
    if (!force && now - lastSync < 400) return syncPromise || Promise.resolve();
    syncing = true; lastSync = now;

    syncPromise = fetchCart().then(function (cart) {
      var q = getCartQualification(cart);
      var giftLines = {}, customerOwn = {};
      cart.items.forEach(function (item) {
        if (isGift(item)) { giftLines[item.variant_id] = item; }
        else if (GIFT_VARIANTS.indexOf(item.variant_id) !== -1) { customerOwn[item.variant_id] = item; }
      });
      renderRewardUI(cart, q);
      if (!debugLogged) { debugLogged = true; log("loaded.", cart.items.length, "items / shop-eq $" + (q.shopTotal / 100).toFixed(2), "(rate " + q.rate + ")"); }

      var chain = Promise.resolve(), didChange = false;
      // 替换制：只保留满足的最高一档，其余礼物行一律撤掉
      var currentTier = highestTier(q);
      TIERS.forEach(function (tier) {
        chain = chain.then(function () {
          var line = giftLines[tier.variantId];
          var hasOwn = !!customerOwn[tier.variantId];
          var isCurrent = !!(currentTier && tier.key === currentTier.key);
          if (hasOwn) { if (line) { didChange = true; return removeGift(line.key); } return; } // 客户自购同款 -> 撤赠品行
          if (isCurrent && !line) { didChange = true; log("add " + tier.name); return addGift(tier.variantId); }
          if (!isCurrent && line) { didChange = true; log("remove " + tier.name); return removeGift(line.key); }
        });
      });

      return chain.then(function () {
        if (!didChange) return;
        return refreshCartSection().then(fetchCart).then(function (c2) { renderRewardUI(c2, getCartQualification(c2)); })
          .catch(function () { renderRewardUI(cart, q); });
      });
    }).catch(function (e) { log("sync failed", e); }).then(function () { syncing = false; syncPromise = null; });
    return syncPromise;
  }

  if (typeof window.fetch !== "function") return;
  var origFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var body = init && init.body ? String(init.body) : "";
    var isCartMutation = /\/cart\/(add|change|update|clear)/.test(url);
    var isOurCall = body.indexOf(GIFT_PROP_KEY) !== -1;
    GIFT_VARIANTS.forEach(function (vid) { if (body.indexOf('"id":"' + vid + ':') !== -1 || body.indexOf('"id": "' + vid + ':') !== -1 || body.indexOf('"updates":{"' + vid + '":') !== -1) isOurCall = true; });
    var result = origFetch(input, init);
    if (isCartMutation && !isOurCall) result.then(function () { setTimeout(sync, 220); });
    return result;
  };

  // ===== checkout guard: 结算前强制 sync 一次 =====
  function findCheckoutTrigger(el) {
    if (!el || !el.closest) return null;
    return el.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [type="submit"][name="checkout"], .cart__checkout-button, .shopify-payment-button__button');
  }
  function continueCheckout(trigger) {
    checkoutGuardBypass = true;
    try {
      var link = trigger && trigger.closest && trigger.closest('a[href*="/checkout"]');
      if (link && link.href) { window.location.href = link.href; return; }
      var form = trigger && (trigger.form || (trigger.closest && trigger.closest("form"))); // v2.3: footer button is outside #cart-form, bound via form="cart-form"
      if (form) {
        if (trigger.name && !form.querySelector('input[type="hidden"][name="' + trigger.name + '"]')) {
          var inp = document.createElement("input"); inp.type = "hidden"; inp.name = trigger.name; inp.value = trigger.value || ""; form.appendChild(inp);
        }
        form.submit(); return;
      }
      window.location.href = "/checkout";
    } finally { setTimeout(function () { checkoutGuardBypass = false; }, 1200); }
  }
  function guardCheckout(ev) {
    if (checkoutGuardBypass) return;
    var trigger = findCheckoutTrigger(ev.target); if (!trigger) return;
    ev.preventDefault(); ev.stopPropagation();
    var done1 = false; var go1 = function () { if (done1) return; done1 = true; continueCheckout(trigger); };
    sync(true).then(go1, go1); setTimeout(go1, 2500); /* DT-CRO 2026-09-03: never let a slow/failed sync swallow the checkout tap */
  }
  function guardCartSubmit(ev) {
    if (checkoutGuardBypass) return;
    var s = ev.submitter || document.activeElement; if (!findCheckoutTrigger(s)) return;
    ev.preventDefault(); ev.stopPropagation();
    var done2 = false; var go2 = function () { if (done2) return; done2 = true; continueCheckout(s); };
    sync(true).then(go2, go2); setTimeout(go2, 2500); /* DT-CRO 2026-09-03 */
  }
  function installCheckoutGuard() { document.addEventListener("click", guardCheckout, true); document.addEventListener("submit", guardCartSubmit, true); }

  function init() { installCheckoutGuard(); setTimeout(function () { sync(); }, 600); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();

  // 重渲染：cart 事件 / 抽屉打开 / snippet 重挂载
  var rT = null;
  function rerender() { clearTimeout(rT); rT = setTimeout(function () { fetchCart().then(function (c) { renderRewardUI(c, getCartQualification(c)); }).catch(function () {}); }, 120); }
  ["cart:update", "cart:refresh", "cart:updated", "cart:change", "discount:update"].forEach(function (ev) { document.addEventListener(ev, rerender); });
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) { var a = muts[i].addedNodes; for (var j = 0; j < a.length; j++) { var n = a[j];
        if (n.nodeType === 1 && ((n.matches && n.matches("[data-darette-rewards]")) || (n.querySelector && n.querySelector("[data-darette-rewards]")))) { rerender(); return; } } }
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
  document.addEventListener("click", function (e) {
    if (e.target.closest('a[href="/cart"], a[href*="/cart"], [data-cart-toggle], .header__cart-link, #cart-icon-bubble, cart-drawer-component')) setTimeout(rerender, 320);
  }, true);
})();
